import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";

interface StateInterface {
  isFetching: boolean;
  fields: string[];
  translatedMessage: string;
  errorId: any;
};

const initialState: StateInterface = {
  isFetching: false,
  fields: [],
  translatedMessage: "",
  errorId: null
};

export const personCreateReducer = (state: StateInterface = initialState, action: ActionInterface): StateInterface => {
  switch (action.type) {
    case Constants.PAGE_CONTACT_PERSON_CREATE_REQUEST:
      return {...state,
        isFetching: true
      };

    case Constants.PAGE_CONTACT_PERSON_CREATE_SUCCESS:
      return {...state,
        isFetching: false
      };

    case Constants.PAGE_CONTACT_PERSON_CREATE_FAILURE:
    case  Constants.PAGE_CONTACT_COMPANY_CREATE_FAILURE:
      return {...state,
        isFetching: false,
        fields: action.payload?.err.fields || [],
        translatedMessage: action.payload?.err.translatedMessage,
        errorId: action.payload?.err.errorId
      };

    case Constants.PAGE_CONTACT_PERSON_CREATE_CLEAR:
    case  Constants.PAGE_CONTACT_COMPANY_CREATE_CLEAR:
      return {
        ...initialState
      };

    case Constants.AUTH_SIGNOUT:
      return {
        ...initialState
      };

    default:
      return state;
  }
};
